import { useTranslate } from '@tolgee/react';
import MatchListPage, {
  MatchListPageProps,
  getServerSideProps as fetcher,
} from '@amf/shared/pages/MatchListPage';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

export default function Page({ navigation, partners, seasons }: MatchListPageProps) {
  const { t } = useTranslate();
  return (
    <Layout navigation={navigation} partners={partners}>
      <Meta title={t('match.list.title')} />
      <MatchListPage seasons={seasons} links={{ match: AppLinks.match, team: AppLinks.team }} />
    </Layout>
  );
}

export const getServerSideProps = fetcher();
